import React, { useEffect, useState } from 'react';
import { Search } from 'carbon-components-react';
import Util from 'utilities/helper.util';
import { useEmptyCallback } from 'utilities/hooks.util';
import { zoomToCenter } from 'components/Map/helper';
import { useSaga } from 'use-reducer-saga';
import reducer, { initialState } from './localStore/reducer';
import sagas from './localStore/sagas';
import { getLotNumSuggestStart } from './localStore/actions';
import ResultsBox from './resultBox';
import { MapPlaceSuggestionCustomFields } from 'types';

const optimizeLabel = (
  label: string,
  customFields: MapPlaceSuggestionCustomFields
) => {
  return `${label} (${Util.toTitleCase(customFields.locality)}, ${
    customFields.region
  })`;
};

const LotNumberSearch: React.FC<Props> = ({ onClose }) => {
  const [localStore, localDispatch] = useSaga(reducer, initialState, sagas);
  const [searchPlanInputValue, setSearchPlanInputValue] = useState<string>('');
  const [searchLotInputValue, setSearchLotInputValue] = useState<string>('');
  const [isShowResult, setIsShowResult] = useState<boolean>(false);

  const { suggestion } = localStore;

  const debouncedFunction = useEmptyCallback(
    Util.debounce(async (args: string[]) => {
      const value = args[0];
      const type = args[1];
      const partnerValue = args[2];

      const query = (
        type === 'PLAN'
          ? `${value} ${partnerValue}`
          : `${partnerValue} ${value}`
      ).trim();

      const payload = {
        query,
        fields: 'region,locality',
        limit: '5'
      };
      localDispatch(getLotNumSuggestStart(payload));
    }, 250)
  );

  const handleInputChange = (type: string, value: string) => {
    type === 'PLAN'
      ? setSearchPlanInputValue(value)
      : setSearchLotInputValue(value);

    debouncedFunction(
      value,
      type,
      type === 'PLAN' ? searchLotInputValue : searchPlanInputValue
    );
  };

  const onClickResult = (item: any) => {
    const center = item.Coordinate.split(',')?.map((c: string) => Number(c));
    zoomToCenter(center, optimizeLabel(item.Value, item.CustomFields));
    onClose();
  };

  useEffect(() => {
    setIsShowResult(suggestion.length > 0);
  }, [suggestion]);

  return (
    <>
      <div className="lot-num-input-container">
        <div className="bx--form-item">
          <label className="bx--label">PLAN</label>
          <Search
            id="plan-input"
            size="xl"
            labelText="PLAN"
            onChange={(evt) => handleInputChange('PLAN', evt.target.value)}
          />
        </div>
        <div className="bx--form-item">
          <label className="bx--label">LOT</label>
          <Search
            id="lot-input"
            size="xl"
            labelText="LOT"
            onChange={(evt) => handleInputChange('LOT', evt.target.value)}
          />
        </div>
      </div>
      {isShowResult && (
        <div className="mls-item-container">
          <ResultsBox
            items={suggestion}
            onItemClick={onClickResult}
            itemToLabel={(item: any) =>
              optimizeLabel(item.Value, item.CustomFields)
            }
          />
        </div>
      )}
    </>
  );
};

type Props = {
  onClose: Function;
};

export default React.memo(LotNumberSearch);
